import * as ReportService from '../../../http/ReportService'
import bus from '../../../plugins/bus'
import router from '../../../router'
import { datadogLogs } from '@datadog/browser-logs'

const actions = {
  getReportData ({ state, commit, dispatch }, token) {
    const url = `${ReportService.REPORT_DATA_ENDPOINT}${token}`

    return new Promise((resolve, reject) => {
      ReportService.getReportData(url).then(response => {
        datadogLogs.setGlobalContext({
          reportId: token,
        })
        if (response.status === 200) {
          commit('setReportPreferences', response.data.preferences)
          commit('createTimestamp', response.data.general.updated_at)
          commit('remapUnknowns')
          dispatch('checkImages', response.data.sections)
            .then(() => {
              commit('createReportSections', response.data.sections)
              commit('mergePreferenceProperty')
              commit('setDataReport', response.data)
              resolve({ status: 'success', data: response.data })
            })
        }
      }, error => {
        reject(error)
      })
    })
  },
  getExpiredReportAgentDetails ({ state, commit, dispatch }, token) {
    const url = `${ReportService.REPORT_DATA_ENDPOINT}${token}${ReportService.EXPIRED_DATA_ENDPOINT}`

    return new Promise((resolve, reject) => {
      ReportService.getReportData(url).then(response => {
        if (response.status === 200) {
          commit('updateReportExpiredContact', response.data)
          router.push('/expired')
          bus.emit('ReportExpired')
          resolve({ status: 'success', data: response.data })
        }
      }, error => {
        reject(error)
      })
    })
  },
  checkImages ({ state, commit }, params) {
    const onTheMarketSection = params.filter(section => section.type === 'market')
    if (onTheMarketSection.length) {
      const propertiesArray = onTheMarketSection[0].data.properties
      const filterImageProcess = (property, i) => {
        const image = property.displayed_image_url
        return new Promise(resolve => {
          let img = document.createElement('img')
          img.src = image
          img.onload = function () {
            if (img.naturalWidth) {
              propertiesArray[i].displayed_image_url = image
              img = null
              resolve(propertiesArray[i])
            } else {
              propertiesArray[i].displayed_image_url = null
              img = null
              resolve(propertiesArray[i])
            }
          }
          img.onerror = function () {
            propertiesArray[i].displayed_image_url = null
            img = null
            resolve(propertiesArray[i])
          }
        })
      }
      return Promise.all(
        propertiesArray.map((property, i) => filterImageProcess(property, i)),
      )
    }
  },
}

export default actions
